import styled from 'styled-components';

import { GridContainer } from '@glowforge/gf-styled/components/grid-container';
import {
  Heading as UnstyledHeading,
  Paragraph as UnstyledParagraph,
} from '@glowforge/gf-styled/components/typography';
import Button from '@glowforge/gf-styled/components/button/button-base';

export const Wrapper = styled(GridContainer)`
  width: 100%;
  background-color: ${(props) => props.theme.colors.backgrounds.gray};

  @media ${(props) => props.theme.queries.desktopAndUp} {
    padding: 64px 0 !important; //TODO: remove with global styles.
  }
`;

export const TextWrapper = styled('div')`
  grid-column: main-start / main-end;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 50px 0;

  ${Button} {
    align-self: center;
  }

  @media ${(props) => props.theme.queries.desktopAndUp} {
    grid-column: col-start 1 / col-end 4;

    ${Button} {
      align-self: flex-start;
    }
  }
`;

export const ImageWrapper = styled('div')`
  grid-column: main-start / main-end;
  display: flex;
  justify-content: center;
  background-image: ${({ image }) => (image ? `url(${image}) ` : '')};
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  // 50vw gives a nice balance between these two numbers, providing a smooth transition.
  height: clamp(280px, 50vw, 480px);

  @media ${(props) => props.theme.queries.desktopAndUp} {
    grid-column: col-start 5 / col-end 12;
    height: unset;
  }
`;

export const Heading = styled(UnstyledHeading)`
  padding-bottom: 24px;
`;

export const Paragraph = styled(UnstyledParagraph)`
  padding-bottom: 24px;
`;
